import { render, staticRenderFns } from "./PicOuterAdd.vue?vue&type=template&id=574d6f87&scoped=true&"
import script from "./PicOuterAdd.vue?vue&type=script&lang=js&"
export * from "./PicOuterAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d6f87",
  null
  
)

export default component.exports